import React, { Component } from 'react';
import { Modal, Button, Form, Row, Col, Card, Badge } from 'react-bootstrap';

class TrustedPersonInfoModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      formData: {}
    };
  }

  componentDidMount() {
    if (this.props.trustedPersonInfo) {
      this.setState({
        formData: { ...this.props.trustedPersonInfo }
      });
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.trustedPersonInfo !== this.props.trustedPersonInfo && this.props.trustedPersonInfo) {
      this.setState({
        formData: { ...this.props.trustedPersonInfo }
      });
    }
  }

  handleInputChange = (field, value) => {
    this.setState(prevState => ({
      formData: {
        ...prevState.formData,
        [field]: value
      }
    }));
  }
  // Map gender from English to Vietnamese
  mapGender = (gender) => {
    if (!gender) return '-';
    switch (gender.toUpperCase()) {
      case 'MALE':
        return 'Nam';
      case 'FEMALE':
        return 'Nữ';
      default:
        return gender;
    }
  }

  // Calculate scan progress percentage
  calculateScanProgress = (matching_c3d_tax_total, matching_c3d_total) => {
    if (!matching_c3d_total || matching_c3d_total === 0) return '0%';
    const percentage = Math.round((matching_c3d_tax_total / matching_c3d_total) * 100);
    return `${percentage}%`;
  }

  render() {
    const { 
      show, 
      onHide, 
      trustedPersonInfo, 
      isEditMode, 
      isCreateMode = false,
      onSave,
      hideStatistics = false
    } = this.props;

    if (!trustedPersonInfo) return null;

    const { formData } = this.state;

    return (
      <Modal show={show} onHide={onHide} size="xl" centered>
        <Modal.Header closeButton>
          <Modal.Title>
            {isCreateMode ? 'Thêm mới Trusted Person' : isEditMode ? 'Chỉnh sửa Trusted Person' : 'Thông tin Trusted Person'}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            {/* Basic Information */}
            <Col md={6}>
              <Card className="mb-3">
                <Card.Header>
                  <h6 className="mb-0">Thông tin cơ bản</h6>
                </Card.Header>
                <Card.Body>
                  <Row>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>MID</Form.Label>
                        {isCreateMode ? (
                          <Form.Control 
                            type="text" 
                            value={formData.MID || ''} 
                            onChange={(e) => this.handleInputChange('MID', e.target.value)}
                            placeholder="Nhập MID thủ công"
                          />
                        ) : (
                          <Form.Control 
                            type="text" 
                            value={formData.MID || ''} 
                            readOnly={!isEditMode}
                            disabled={isEditMode} // MID should not be editable in edit mode
                          />
                        )}
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>Trạng thái Etsy</Form.Label>
                        {isEditMode ? (
                          <Form.Select
                            value={formData.is_registered_etsy ? 'true' : 'false'}
                            onChange={(e) => this.handleInputChange('is_registered_etsy', e.target.value === 'true')}
                          >
                            <option value="false">Chưa đăng ký</option>
                            <option value="true">Đã đăng ký</option>
                          </Form.Select>
                        ) : (
                          <div>
                            <Badge bg={formData.is_registered_etsy ? "success" : "secondary"}>
                              {formData.is_registered_etsy ? "Đã đăng ký" : "Chưa đăng ký"}
                            </Badge>
                          </div>
                        )}
                      </Form.Group>
                    </Col>
                  </Row>
                  
                  <Row>
                    <Col md={12}>
                      <Form.Group className="mb-3">
                        <Form.Label>Tên đầy đủ</Form.Label>
                        <Form.Control 
                          type="text" 
                          value={formData.full_name || ''} 
                          readOnly={!isEditMode}
                          onChange={isEditMode ? (e) => this.handleInputChange('full_name', e.target.value) : undefined}
                        />
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row>
                    <Col md={12}>
                      <Form.Group className="mb-3">
                        <Form.Label>Tên tiếng Anh</Form.Label>
                        <Form.Control 
                          type="text" 
                          value={formData.full_name_english || ''} 
                          readOnly={!isEditMode}
                          onChange={isEditMode ? (e) => this.handleInputChange('full_name_english', e.target.value) : undefined}
                        />
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>Đầu mối</Form.Label>
                        {isEditMode ? (
                          <Form.Select
                            value={formData.relation_with || ''}
                            onChange={(e) => this.handleInputChange('relation_with', e.target.value)}
                          >
                            <option value="">Chọn đầu mối</option>
                            <option value="Nguyễn Việt Anh">Nguyễn Việt Anh</option>
                            <option value="Đinh Công Trường">Đinh Công Trường</option>
                            <option value="Vũ Phương Thảo">Vũ Phương Thảo</option>
                          </Form.Select>
                        ) : (
                          <Form.Control 
                            type="text" 
                            value={formData.relation_with || ''} 
                            readOnly
                          />
                        )}
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>Ghi chú quan hệ</Form.Label>
                        <Form.Control 
                          type="text" 
                          value={formData.relation_note || ''} 
                          readOnly={!isEditMode}
                          onChange={isEditMode ? (e) => this.handleInputChange('relation_note', e.target.value) : undefined}
                        />
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>Trạng thái</Form.Label>
                        {isEditMode ? (
                          <Form.Select
                            value={formData.status || 'draft'}
                            onChange={(e) => this.handleInputChange('status', e.target.value)}
                          >
                            <option value="draft">Draft</option>
                            <option value="publish">Publish</option>
                            <option value="deactive">Deactive</option>
                          </Form.Select>
                        ) : (
                          <div>
                            <Badge bg={
                              formData.status === 'publish' ? 'success' :
                              formData.status === 'deactive' ? 'danger' :
                              'secondary'
                            }>
                              {formData.status === 'publish' ? 'Publish' :
                               formData.status === 'deactive' ? 'Deactive' :
                               'Draft'}
                            </Badge>
                          </div>
                        )}
                      </Form.Group>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            </Col>

            {/* C3D Information */}
            <Col md={6}>
              <Card className="mb-3">
                <Card.Header>
                  <h6 className="mb-0">Thông tin C3D</h6>
                </Card.Header>
                <Card.Body>
                  <Row>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>Số C3D</Form.Label>
                        <Form.Control 
                          type="text" 
                          value={formData.c3d_number || ''} 
                          readOnly={!isEditMode}
                          onChange={isEditMode ? (e) => this.handleInputChange('c3d_number', e.target.value) : undefined}
                        />
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>Ngày sinh</Form.Label>
                        <Form.Control 
                          type="text" 
                          value={formData.c3d_dob || ''} 
                          readOnly={!isEditMode}
                          onChange={isEditMode ? (e) => this.handleInputChange('c3d_dob', e.target.value) : undefined}
                        />
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>Giới tính</Form.Label>
                        {isEditMode ? (
                          <Form.Select
                            value={formData.c3d_sex || ''}
                            onChange={(e) => this.handleInputChange('c3d_sex', e.target.value)}
                          >
                            <option value="">Chọn giới tính</option>
                            <option value="MALE">Nam</option>
                            <option value="FEMALE">Nữ</option>
                          </Form.Select>
                        ) : (
                          <Form.Control 
                            type="text" 
                            value={this.mapGender(formData.c3d_sex)} 
                            readOnly
                          />
                        )}
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>Thành phố</Form.Label>
                        <Form.Control 
                          type="text" 
                          value={formData.c3d_city || ''} 
                          readOnly={!isEditMode}
                          onChange={isEditMode ? (e) => this.handleInputChange('c3d_city', e.target.value) : undefined}
                        />
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row>
                    <Col md={12}>
                      <Form.Group className="mb-3">
                        <Form.Label>Nơi sinh</Form.Label>
                        <Form.Control 
                          type="text" 
                          value={formData.c3d_place_of_origin || ''} 
                          readOnly={!isEditMode}
                          onChange={isEditMode ? (e) => this.handleInputChange('c3d_place_of_origin', e.target.value) : undefined}
                        />
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row>
                    <Col md={12}>
                      <Form.Group className="mb-3">
                        <Form.Label>Nơi cư trú</Form.Label>
                        <Form.Control 
                          type="text" 
                          value={formData.c3d_place_of_residence || ''} 
                          readOnly={!isEditMode}
                          onChange={isEditMode ? (e) => this.handleInputChange('c3d_place_of_residence', e.target.value) : undefined}
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            </Col>
          </Row>

          <Row>
            {/* Contact Information */}
            <Col md={6}>
              <Card className="mb-3">
                <Card.Header>
                  <h6 className="mb-0">Thông tin liên hệ</h6>
                </Card.Header>
                <Card.Body>
                  <Row>
                    <Col md={12}>
                      <Form.Group className="mb-3">
                        <Form.Label>Địa chỉ</Form.Label>
                        <Form.Control 
                          as="textarea" 
                          rows={3}
                          value={formData.address || ''} 
                          readOnly={!isEditMode}
                          onChange={isEditMode ? (e) => this.handleInputChange('address', e.target.value) : undefined}
                        />
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>Số điện thoại</Form.Label>
                        <Form.Control 
                          type="text" 
                          value={formData.phone || ''} 
                          readOnly={!isEditMode}
                          onChange={isEditMode ? (e) => this.handleInputChange('phone', e.target.value) : undefined}
                        />
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>Thành phố hiện tại</Form.Label>
                        <Form.Control 
                          type="text" 
                          value={formData.current_city || ''} 
                          readOnly={!isEditMode}
                          onChange={isEditMode ? (e) => this.handleInputChange('current_city', e.target.value) : undefined}
                        />
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row>
                    <Col md={12}>
                      <Form.Group className="mb-3">
                        <Form.Label>Ghi chú liên hệ</Form.Label>
                        <Form.Control 
                          as="textarea" 
                          rows={2}
                          value={formData.contact_note || ''} 
                          readOnly={!isEditMode}
                          onChange={isEditMode ? (e) => this.handleInputChange('contact_note', e.target.value) : undefined}
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            </Col>

            {/* Statistics - Only show if hideStatistics is false */}
            {!hideStatistics && (
              <Col md={6}>
                <Card className="mb-3">
                  <Card.Header>
                    <h6 className="mb-0">Thống kê</h6>
                  </Card.Header>
                  <Card.Body>
                    <Row>
                      <Col md={6}>
                        <Form.Group className="mb-3">
                          <Form.Label>Tổng số C3D</Form.Label>
                          <Form.Control 
                            type="text" 
                            value={formData.matching_c3d_total || 0} 
                            readOnly
                          />
                        </Form.Group>
                      </Col>
                      <Col md={6}>
                        <Form.Group className="mb-3">
                          <Form.Label>C3D đã kiểm tra thuế</Form.Label>
                          <Form.Control 
                            type="text" 
                            value={formData.matching_c3d_tax_total || 0} 
                            readOnly
                          />
                        </Form.Group>
                      </Col>
                    </Row>

                    <Row>
                      <Col md={12}>
                        <Form.Group className="mb-3">
                          <Form.Label>Tiến độ scan</Form.Label>
                          <div className="d-flex align-items-center gap-2">
                            <Badge 
                              bg={
                                this.calculateScanProgress(formData.matching_c3d_tax_total, formData.matching_c3d_total) === '100%' ? 'success' :
                                this.calculateScanProgress(formData.matching_c3d_tax_total, formData.matching_c3d_total) === '0%' ? 'secondary' :
                                'warning'
                              }
                              style={{ fontSize: '0.8em', padding: '4px 8px' }}
                            >
                              {this.calculateScanProgress(formData.matching_c3d_tax_total, formData.matching_c3d_total)}
                            </Badge>
                            <small className="text-muted">
                              ({formData.matching_c3d_tax_total || 0}/{formData.matching_c3d_total || 0})
                            </small>
                          </div>
                        </Form.Group>
                      </Col>
                    </Row>

                    <Row>
                      <Col md={6}>
                        <Form.Group className="mb-3">
                          <Form.Label>Trạng thái</Form.Label>
                          <div>
                            <Badge bg={formData.is_deleted ? "danger" : "success"}>
                              {formData.is_deleted ? "Đã xóa" : "Hoạt động"}
                            </Badge>
                          </div>
                        </Form.Group>
                      </Col>
                      <Col md={6}>
                        <Form.Group className="mb-3">
                          <Form.Label>Ngày cập nhật</Form.Label>
                          <Form.Control 
                            type="text" 
                            value={formData.updated_at ? new Date(formData.updated_at).toLocaleDateString('vi-VN') : '-'} 
                            readOnly
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                  </Card.Body>
                </Card>
              </Col>
            )}
          </Row>

          {/* C3D Photos */}
          {formData.c3d_photos && formData.c3d_photos.length > 0 && (
            <Row>
              <Col md={12}>
                <Card className="mb-3">
                  <Card.Header>
                    <h6 className="mb-0">Ảnh C3D ({formData.c3d_photos.length})</h6>
                  </Card.Header>
                  <Card.Body>
                    <div className="d-flex flex-wrap gap-2">
                      {formData.c3d_photos.map((photo, index) => (
                        <img 
                          key={index}
                          src={photo} 
                          alt={`C3D Photo ${index + 1}`}
                          style={{ 
                            width: '100px', 
                            height: '100px', 
                            objectFit: 'cover',
                            borderRadius: '4px',
                            border: '1px solid #dee2e6',
                            cursor: 'pointer'
                          }}
                          onClick={() => window.open(photo, '_blank')}
                        />
                      ))}
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          )}

          {/* C3D Metadata */}
          {formData.c3d_metadata && (
            <Row>
              <Col md={12}>
                <Card className="mb-3">
                  <Card.Header>
                    <h6 className="mb-0">Metadata C3D</h6>
                  </Card.Header>
                  <Card.Body>
                    <pre style={{ 
                      backgroundColor: '#f8f9fa', 
                      padding: '10px', 
                      borderRadius: '4px',
                      fontSize: '12px',
                      maxHeight: '200px',
                      overflow: 'auto'
                    }}>
                      {JSON.stringify(formData.c3d_metadata, null, 2)}
                    </pre>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={onHide}>
            Đóng
          </Button>
          {isEditMode && (
            <Button variant="primary" onClick={() => onSave && onSave(formData)}>
              {isCreateMode ? 'Tạo mới' : 'Lưu thay đổi'}
            </Button>
          )}
        </Modal.Footer>
      </Modal>
    );
  }
}

export default TrustedPersonInfoModal;
